<p-menubar *ngIf="!hideMenuBar">
    <ng-template pTemplate="start" style="width: 100%;">
        <div class="p-d-flex p-jc-between">
            <div>
                <button pButton pRipple type="button" label="Logs" class="p-button-text" (click)="setActive('Log')" [class.p-button-secondary]="activeButton!=='Log'"></button>
                <button *ngIf="!isLogOnly" pButton pRipple type="button" label="Emails" class="p-button-text" (click)="setActive('Email')" [class.p-button-secondary]="activeButton!=='Email'"></button>
                <button *ngIf="!isLogOnly" pButton pRipple type="button" label="Tasks" class="p-button-text" (click)="setActive('Task')" [class.p-button-secondary]="activeButton!=='Task'"></button>
                <button *ngIf="!isLogOnly && objectTypeId !== caseModuleId" pButton pRipple type="button" label="Event" class="p-button-text" (click)="setActive('Event')" [class.p-button-secondary]="activeButton!=='Event'"></button>
            </div>

            <span class="p-d-flex p-ai-center">
                <span *ngIf="activeButton !== 'Task' && activeButton !== 'Event'">
                    <button pButton size="small" type="button" [label]="expandCollapseText" (click)="expanAllActivities()" class="p-mr-2"></button>
                </span>
                <span class="btnBars p-mr-0 p-ml-2" *ngIf="!hideEmailSyncIcon && activeButton == 'Email'">
                    <i class="pi pi-refresh" tooltipPosition="top" pTooltip="Email Sync" (click)="emailSync()"  *ngIf="!showSpinner" ></i>
                    <i class="pi pi-spin pi-spinner"
                        style="font-size: 1rem"
                        *ngIf="showSpinner" tooltipPosition="top"
                        [pTooltip]="emailSyncTooltip">
                    </i>
                </span>

                <span class="btnBarsKanban" *ngIf="activeButton == 'Log'" pTooltip="Refresh List" tooltipPosition="top" (click)="getActivityTimeline()">
                    <i class="pi pi-refresh p-cursor-pointer"></i>
                </span>

                <span class="btnBars p-mr-0 p-ml-2" *ngIf="activeButton !== 'Task' && activeButton !== 'Event'" (click)="openAllActivityList()" tooltipPosition="top" pTooltip="All Activity List">
                    <i class="pi pi-inbox"></i>
                </span>
                <span class="btnBars p-mr-0" (click)="filterItems.toggle($event)" tooltipPosition="top" pTooltip="Filter"
                *ngIf="activeButton == 'Log'">
                    <i class="pi pi-filter"></i>
                </span>

                <span *ngIf="!isViewMode && activeButton == 'Log'" class="btnBars p-ml-2 p-mr-0" (click)="openLogs()">
                    <i class="pi pi-plus"></i>
                </span>
                <span *ngIf="!isViewMode && activeButton == 'Email'" class="btnBars p-ml-2 p-mr-0" (click)="populateDraftCount()">
                    <i class="pi pi-plus"></i>
                </span>
            </span>
        </div>
    </ng-template>
</p-menubar>

<p-overlayPanel #filterItems styleClass="activityItems">
    <ng-template pTemplate>
        <ul>
            <li (click)="filterActivities(filters.ALL_ACTIVITY); filterItems.hide($event)" [class.active]="filterType === filters.ALL_ACTIVITY">
                <span>All Activity</span>
            </li>
            <li (click)="filterActivities(filters.USER_ACTIVITY); filterItems.hide($event)" [class.active]="filterType === filters.USER_ACTIVITY">
                <span>User Activity</span>
            </li>
            <li (click)="filterActivities(filters.SYSTEM_ACTIVITY); filterItems.hide($event)" [class.active]="filterType === filters.SYSTEM_ACTIVITY">
                <span>System Activity</span>
            </li>
            <li (click)="filterActivities(filters.FAVORITE); filterItems.hide($event)" [class.active]="filterType === filters.FAVORITE">
                <span>Favorite</span>
            </li>
        </ul>
    </ng-template>
</p-overlayPanel>

<div *ngIf="loadingActivityLogs && !showTaskTable && !showEvent"  class="p-d-flex p-ai-center p-jc-center p-mt-3" [style]="{height: '40px'}">
    <p-progressSpinner styleClass="activity-custom-spinner" animationDuration=".5s"></p-progressSpinner>
</div>

<div *ngIf="!loadingActivityLogs && !showTaskTable && !showEvent" class="p-mt-3 activity-timeline-wrapper">
    <div class="timeline" *ngFor="let stageDetails of activityLogTimelines; let i=index">
        <div class="timeline-separator">
            <div class="timeline-marker" [ngStyle]="{ 'border-color': stageDetails?.stageColor }"></div>
            <div class="timeline-connector" [ngStyle]="{ 'height': '100%', 'background-color': stageDetails?.stageColor }"></div>
        </div>
        <div class="timeline-right">
            <h6 class="timeline-stage-info">
                <button type="button" pButton pRipple
                    class="p-button-text p-button-rounded p-button-plain group-expand-button"
                    (click)="toogleTimelineActivity(stageDetails)"
                    [icon]="stageDetails?.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                </button>
                <div class="timeline-stage">
                    {{stageDetails.stageName}}
                    <span class="font-light">({{ stageDetails.fromDate | localDate }} - {{ i==0 ? 'Current' : stageDetails.toDate | localDate }})</span>
                    <span class="p-ml-2 font-light pi pi-clock"></span> <span class="font-light">{{ stageDetails.fromDate | convertDateToDhms:stageDetails.toDate }}</span>
                </div>
                <ng-container *ngIf="stageDetails?.activityCounts?.length>0">
                    <div class="timeline-activity-counts" [ngClass]="{'activity-count-filter-active': stageDetails?.filteredCounts}">
                        <ng-container *ngFor="let activityCount of stageDetails?.activityCounts">
                            <div (click)="filterActivitiesByCount(stageDetails,activityCount)" class="activity-icon cursor-pointer {{activityCount.colorClass}} p-shadow-3" [ngClass]="{'activity-count-filter': stageDetails?.filteredCounts?.id==activityCount.id}" tooltipPosition="top" [pTooltip]="activityCount?.activityName">
                                <span *ngIf="!(activityCount.subTypes.length>0 && ['Inbound Call','Outbound Call'].includes(activityCount.subTypes[0]))" [class]="activityCount.icon"></span>
                                <img [src]="assestBaseUrl + 'icons/incoming-call.png'" alt="incomingCall"  style="width: 12px;" *ngIf="activityCount.subTypes.length>0 && activityCount.subTypes[0] == 'Inbound Call'" />
                                <img [src]="assestBaseUrl + 'icons/outgoing-call.png'" alt="outgoingCall" style="width: 12px;" *ngIf="activityCount.subTypes.length>0 && activityCount.subTypes[0] == 'Outbound Call'" />
                                <span class="activity-count">{{ activityCount.counts }}</span>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </h6>
            <div class="timeline-activity p-pb-2" [ngClass]="{'p-d-none': !stageDetails?.expanded}">
                <app-shared-activity-list-template
                    [channelId]="channelId"
                    [selectedObject]="selectedObject"
                    [objectId]="objectId"
                    [objectTypeId]="objectTypeId"
                    [currentStageId]="currentStageId"
                    [objectType]="objectType"
                    [contacts]="contacts"
                    [selectedObjectStages]="selectedObjectStages"
                    [isViewMode]="isViewMode"
                    [allActivityLogs]="stageDetails.activities"
                    (getActivityTimelineList)="getActivityTimeline(null, stageDetails, $event)">
                </app-shared-activity-list-template>
            </div>

        </div>
    </div>
</div>

<ng-container *ngIf="showTaskTable">
    <app-lion-shared-task-listing [selectedAccount]="selectedObject" [objectTypeId]="objectTypeId" [isSidebar]="true">
    </app-lion-shared-task-listing>
</ng-container>

<p-card class="activity-card" *ngIf="(!activityLogTimelines || !activityLogTimelines.length) && !loadingActivityLogs">
    <div>
        <h6 class="p-mb-1" style="display: inline-block;">
            No Activities Found.
        </h6>
    </div>
</p-card>

<app-shared-activities-list
    *ngIf="displayAllActivityLists"
    [currentDisplay]="displayAllActivityLists"
    [channelId]="channelId"
    [currentStageId]="currentStageId"
    [selectedObject]="selectedObject"
    [objectId]="objectId"
    [objectTypeId]="objectTypeId"
    [objectType]="objectType"
    [contacts]="contacts"
    [selectedObjectStages]="selectedObjectStages"
    [isViewMode]="isViewMode"
    (dialogClosed)="closeActivityDialog()">
</app-shared-activities-list>

<app-lion-shared-emails [displaySendEmail]="displaySendEmail" [contacts]="contacts" [selectedObject]="selectedObject" [channelId]="channelId" [objectId]="objectId" [objectTypeId]="objectTypeId" (cancelEmail)="cancelEmail($event)"
    (syncSendEmail)="syncSendEmail($event)">
</app-lion-shared-emails>

<app-lion-shared-logs *ngIf="displayAddLog" [displayAddLog]="displayAddLog" (cancelLog)="cancelLog($event)">
</app-lion-shared-logs>

<app-lion-activity-sidebar *ngIf="!hideRigthArrow" [objectId]="objectId" [objectType]="objectType" [isViewMode]="isViewMode" [selectedObject]="selectedObject" (taskAdded)="newTaskAdded()">
</app-lion-activity-sidebar>

<app-shared-calendar *ngIf="showEvent" [objectId]="objectId" [objectTypeId]="objectTypeId" [channelId]="channelId" [eventFromModule]="true" [selectedAccount]="selectedObject" [isSidebar]="true">
